import angular from 'angular';
import NavbarComponent from './navbar-component';

export default angular
  .module('navbar', [])
  .component('navbar', new NavbarComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/navbar/navbar-module.js